module.exports = __webpack_public_path__ + "media/images/set-limit-action-icon-48ff4c30c2400c29956c99d89aeb4b32.svg";